
















import InputField from "./InputField";
const Cleave = require("vue-cleave-component");

export default {
    name: "DateInput",
    components: { InputField, Cleave },
    props: {
        label: String,
        value: String,
    },
    data() {
        return {
            editString: "",
            options: {
                date: true,
                datePattern: ["d", "m", "Y"],
            },
        };
    },
    created() {
        this.editString = this.value;
    },
    watch: {
        editString: function () {
            this.$emit("input", this.editString);
        },
    },
};
